import {AbstractMainPlugin} from "../../AbstractMainPlugin";
import {Item} from "../../../models/Item";
import {ServerConnectionService} from "../../../services/serverConnection/server-connection.service";
import {appInjector} from "../../appInjector";
import {throttle} from "rxjs/operators";
import {interval, timer} from "rxjs";
import {ActionLogService} from "../../../services/actionLogService/action-log.service";
import {ItemConfig} from "../../../models/ItemConfig";
import {GroupService} from "../../../services/groupService/group-service.service";


export class ItemListenerPlugin extends AbstractMainPlugin {
  private actionLogger : ActionLogService;
  private groupS : GroupService;
  private oldConfig = null;
  private canAddToConfig = true;
  constructor(item:Item) {
    super(item);
    this.actionLogger = appInjector.get(ActionLogService);
    this.groupS = appInjector.get(GroupService);
    this.oldConfig = item.config.asJSON();
    item.config.subject
      // .pipe(throttle(config => interval(1000), {trailing: true}))
      .subscribe((config) => {
        if (this.oldConfig == config.asJSON()){
          return;
        }
        if (item.getSubjectValue('skipOneActionUpdate')) {
          item.getSubject('skipOneActionUpdate').next(false);
          this.oldConfig = config.asJSON();
          return;
        }
        if (this.canAddToConfig){
          this.actionLogger.addToConfig(this.oldConfig, 'update');
          this.oldConfig = config.asJSON();
        }
      });

    item.emitter.subscribe((e)=>{
      if (e.getEventName() == 'removeObject' && !e.getIsSilent()){
        if (!e.getIsGroupListener()){
          this.actionLogger.addToConfig(this.oldConfig, 'remove');
        }
        if (this.item.config.getGroupId()){
          const group = this.groupS.getGroupById(this.item.config.getGroupId());
          group.removeItem(this.item);
        }
      }
    });

    item.getSubject(Item.UNDO_SUBJECT).subscribe((config)=>{
      const undoConfig = Object.assign({}, this.oldConfig ? JSON.parse(this.oldConfig) : {});
      if (config.hasOwnProperty('actionId') && config.actionId) {
        undoConfig.actionId = config.actionId;
      }
      this.actionLogger.addToConfig(JSON.stringify(undoConfig), 'add');
    });

    item.getObservable('updateOldListenerConfig').subscribe((config:ItemConfig)=>{
      this.oldConfig = config.asJSON();
      this.canAddToConfig = false;
      timer(1000).subscribe(()=>{
        this.canAddToConfig = true;
      })
    });

    item.getObservable('addedByConfig').subscribe((id)=>{
      this.actionLogger.changeUndoConfigsItemStatus('pending', id);
    })


  }
}
